
import { defineComponent, PropType } from 'vue'
import FilterGeneric, { FilterChoice } from '~/components/Common/FilterGeneric.vue'
import { CodeCoverageT, CoverageSortT } from '~/types/reportTypes'

export default defineComponent({
  name: 'CodeCoverageSort',
  components: {
    FilterGeneric
  },
  model: {
    prop: 'selectedCoverageSortFilter',
    event: 'updateCoverageSortFilter'
  },
  props: {
    selectedCoverageSortFilter: {
      type: String as PropType<CoverageSortT>,
      required: true
    },
    coverageFilters: {
      type: Object as PropType<{ [key in CoverageSortT]?: FilterChoice }>,
      required: true
    },
    coverageType: {
      type: String as PropType<CodeCoverageT>,
      required: true
    },
    defaultLabel: {
      type: String,
      required: true
    }
  },
  computed: {
    coverageSortFilter: {
      get() {
        return this.selectedCoverageSortFilter
      },
      set(val: CoverageSortT) {
        this.$emit('updateCoverageSortFilter', val)
      }
    },
    nextSort(): CoverageSortT {
      return this.newSortValue(this.coverageType, this.coverageSortFilter)
    }
  },
  methods: {
    newSortValue(coverageType: CodeCoverageT, coverageSortFilter: CoverageSortT): CoverageSortT {
      if (coverageType === CodeCoverageT.BCV) {
        if (coverageSortFilter === CoverageSortT.BCV_ASCENDING) {
          return CoverageSortT.BCV_DESCENDING
        } else if (coverageSortFilter === CoverageSortT.BCV_DESCENDING) {
          return '' as CoverageSortT
        } else {
          return CoverageSortT.BCV_ASCENDING
        }
      }

      if (coverageType === CodeCoverageT.LCV) {
        if (coverageSortFilter === CoverageSortT.LCV_ASCENDING) {
          return CoverageSortT.LCV_DESCENDING
        } else if (coverageSortFilter === CoverageSortT.LCV_DESCENDING) {
          return '' as CoverageSortT
        } else {
          return CoverageSortT.LCV_ASCENDING
        }
      }

      return '' as CoverageSortT
    }
  }
})
